export default __webpack_public_path__ + "f6817de12463ee1dd6dd60e2cde5541c.jpg";